import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24c66827"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ukraine-popup" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Radio = _resolveComponent("Radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.paragraphOneContent`)), 1),
    _createVNode(_component_Radio, {
      label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.radioOne`),
      name: "ukraineAddress",
      value: true,
      checked: true,
      onUpdateValue: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ukraineAddress = $event))
    }, null, 8, ["label"]),
    _createVNode(_component_Radio, {
      label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.radioTwo`),
      name: "ukraineAddress",
      value: false,
      onUpdateValue: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ukraineAddress = $event))
    }, null, 8, ["label"]),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      class: "button button--submit",
      disabled: _ctx.ukraineAddress === null,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEuAddress && _ctx.handleEuAddress(...args)))
    }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.next`)), 9, _hoisted_2), [
      [_vShow, _ctx.ukraineAddress]
    ]),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      class: "button button--submit",
      disabled: _ctx.ukraineAddress === null,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleRedirect && _ctx.handleRedirect(...args)))
    }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.next`)), 9, _hoisted_3), [
      [_vShow, !_ctx.ukraineAddress]
    ])
  ]))
}